import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "./cn";

export type BadgeVariant = "discount" | "hot" | "new" | "info" | "yellow";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const VARIANTS: Record<BadgeVariant, string> = {
  discount: "bg-price text-white",
  hot: "bg-cta text-white",
  new: "bg-secondary text-white",
  info: "bg-info-soft text-info",
  yellow: "bg-sticker-yellow-soft text-sticker-yellow-fg",
};

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = "info", ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center rounded-sm px-2 py-0.5 text-overline font-bold uppercase",
        VARIANTS[variant],
        className,
      )}
      {...props}
    />
  ),
);
Badge.displayName = "Badge";
